import { createActionGroup, props } from '@ngrx/store';
import { NationalityEntity } from './nationality.entity';
import { NationalityModel } from '@core/data-access';
import { ObjectNumber } from '../../type';

export type NationalityInitProps = {
  nationalities: NationalityModel[];
};

export type NationalityLoadSuccessProps = {
  entities: NationalityEntity[];
};

export const NationalityActions = createActionGroup({
  source: 'Nationality',
  events: {
    Init: props<NationalityInitProps>(),
    'Load Success': props<NationalityLoadSuccessProps>(),
    'Load Failure': props<{ error: any }>(),
    'Load SingPass Map': props<{ singpassMap: ObjectNumber }>(),
  },
});
